import * as React from "react";
import Box from "@mui/material/Box";
import { Tab, Tabs, Typography } from "@mui/material";
import UpCommingAppoiments from "./UpcommingAppoiments";
import AppointmentHistory from "./AppointmentHistorr";
import OnlineAppoitment from "./OnlineAppoitment";
import "../../index.css";

interface IProps {
  Data: any;
}
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const PatientsEditModal = ({ Data }: IProps) => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            backgroundColor: "grey",
            marginLeft: "10px",
            color: "red",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              className="TabColor"
              label="Upcoming Appointments"
              {...a11yProps(0)}
            />
            <Tab
              className="TabColor"
              label="Appointment History"
              {...a11yProps(1)}
            />
            <Tab
              className="TabColor"
              label="Online Appointment"
              {...a11yProps(2)}
            />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          {<UpCommingAppoiments Data={Data} />}
        </TabPanel>
        <TabPanel value={value} index={1}>
          {<AppointmentHistory Data={Data} />}
        </TabPanel>
        <TabPanel value={value} index={2}>
          {<OnlineAppoitment Data={Data} />}
        </TabPanel>
      </Box>
    </>
  );
};

export default PatientsEditModal;
